import bowser from 'bowser';

export default angular
  .module('doxy.common.services.screenshareFactory', [])
  .factory(
    'screenshareFactory',
    function (Browser, notificationFactory, globalUi) {
      function notSupported() {
        notificationFactory.showCommon(
          'error',
          'Current browser does not support screensharing, please use Chrome or Firefox instead.'
        );
      }

      function pluginNotInstalled() {
        let message = undefined;

        if (bowser.firefox) {
          message = 'Please update your browser to the latest version.';
        }

        if (message) notificationFactory.showUnsafeMessage('info', message);
      }

      function getErrorMessageKey() {
        if (Browser.isMacOs() && !Browser.isSafari()) {
          return 'screenshare-not-supported-macos';
        }
        if (Browser.isMacOs() && Browser.isSafari()) {
          return 'screenshare-not-supported-macos-safari';
        }

        return 'screenshare-not-supported-common';
      }

      return {
        pluginNotInstalled,
        notSupported,
        handleError(error) {
          globalUi.ui.screenSharing = false;
          switch (error.code) {
            case 1500:
              const messageKey = getErrorMessageKey();
              notificationFactory.showCommon('info', messageKey);
              break;
            default:
              notificationFactory.showCommon(
                'error',
                'Could not start screensharing.'
              );
            // notificationFactory.showCommon('info', 'screenshare-random-error');
          }
        },
      };
    }
  ).name;
